import { useState } from 'react';

export interface DrawerApi {
  open: () => void;
  close: () => void;
  isOpen: boolean;
}

const useDrawer = (): DrawerApi => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  return {
    open,
    close,
    isOpen,
  };
};

export default useDrawer;
